// Version du bundle, bakée au build.
//
// ⚠️ B1051 (Eric 2026-09-04) — Cette string DOIT être identique à
// `APP_BUILD_VERSION` dans `backend/routers/version.py`. La cohérence est
// vérifiée par le test de garde
// `backend/tests/test_b1051_no_forced_reload.py::test_backend_and_frontend_versions_match`
// qui casse la CI si les deux divergent.
//
// AVANT B1051, le backend lisait CE fichier sur le disque au boot pour
// éviter le drift. Ça échouait en prod (l'image backend ne contient pas
// `frontend/`) → /api/version renvoyait "unknown" → le « version gate »
// d'index.html forçait 2 rechargements de page à chaque visite → le POST
// de login était coupé en vol. Le gate a été SUPPRIMÉ (aucun rechargement
// automatique n'existe plus nulle part) et le backend porte sa propre
// constante. Voir backend/routers/version.py pour le RCA complet.
//
// Bumper cette string sert uniquement à afficher le bandeau « Nouvelle
// version disponible » (bouton Recharger, cliqué par l'utilisateur) quand
// un déploiement a lieu pendant une session active.
export const APP_VERSION = "2026-09-04-b1051-no-forced-reload";
